<div class="uni-add-container">
  <p>Please manually add your university or college below</p>
  <input type="text" [value]="prefill" #uniName />
  <button
    (click)="addUni($event)"
    [disabled]="adding"
    [class.button-loading]="adding"
    [class.button-loading-disabled]="adding"
  >
    <span>Submit</span>
  </button>
</div>
